var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-toolbar",
                { attrs: { color: "green darken-3", dark: "", dense: "" } },
                [
                  _c("span", [_vm._v("New Category")]),
                  _c("v-spacer"),
                  _c("v-icon", [_vm._v("mdi-shape")])
                ],
                1
              ),
              _vm._l(_vm.custCatPostErrors, function(item, index) {
                return _c(
                  "v-alert",
                  {
                    key: index,
                    staticClass: "mt-2",
                    attrs: { type: "error", dismissible: "" }
                  },
                  [
                    _c("span", { staticClass: "text-uppercase" }, [
                      _vm._v(_vm._s(item.first()))
                    ])
                  ]
                )
              })
            ],
            2
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "Category ID" },
                model: {
                  value: _vm.id,
                  callback: function($$v) {
                    _vm.id = $$v
                  },
                  expression: "id"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "Name" },
                model: {
                  value: _vm.name,
                  callback: function($$v) {
                    _vm.name = $$v
                  },
                  expression: "name"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    dark: "",
                    loading: _vm.custCatPosting
                  },
                  on: { click: _vm.storeCustCat }
                },
                [_vm._v(" Save ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }